"use strict";
// feature summarizing modes
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUMMARY = {
    MEAN: "mean",
    MEDIAN: "median",
    MODE: "mode",
    FIRST: "first",
};



//////////////////
// WEBPACK FOOTER
// ./~/dymo-core/lib/generator/globals.js
// module id = 640
// module chunks = 3